import React, { useState, useEffect } from "react";
import TechniqueInput from "../testing/TechniqueInput";
import TestingCategoriesSelect from "../result_notifications/TestingCategoriesSelect";
import TechniquesSelect from "../result_notifications/TechniquesSelect";
import MatricesSelect from "../result_notifications/MatricesSelect";
import Button from "../Button";
import Link from "../Link";
import CompanyDropDown from "../crm/CompanyDropDown";
import styled from "styled-components";
import { toJS } from "mobx";

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  width: fit-content;
  > div {
    margin-right: 10px;
  }
`;

export default function TraySearch({ onSearch }) {
  const [testingCategoryIds, setTestingCategoryIds] = useState([]);
  const [techniqueIds, setTechniqueIds] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [exceedAnalysisTime, setExceedAnalysisTime] = useState(false);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [includeTechniques, setIncludeTechniques] = useState(false);
  const [matrixIds, setMatrixIds] = useState([]);
  const storageKey = "tray_search_params";

  const params = {
    technique_ids: techniqueIds,
    testing_category_ids: testingCategoryIds,
    company_id: companyId,
    exceed_analysis_time: exceedAnalysisTime,
    include_techniques: includeTechniques,
    matrix_ids: matrixIds,
  };

  const handleSearch = () => {
    onSearch(params);
  };

  useEffect(() => {
    console.log("Sk", localStorage.getItem(storageKey));
    const {
      techniqueIds: newTechniqueIds,
      testingCategoryIds: newTestingCategoryIds,
    } = JSON.parse(localStorage.getItem(storageKey) || "{}");
    if (newTestingCategoryIds) setTestingCategoryIds(newTestingCategoryIds);
    if (newTechniqueIds) setTechniqueIds(newTechniqueIds);
  }, []);

  useEffect(
    () => {
      localStorage.setItem(
        storageKey,
        JSON.stringify(toJS({ techniqueIds, testingCategoryIds }))
      );
    },
    [params]
  );

  return (
    <div
      className=""
      style={{ padding: 0, marginBottom: 10, margin: "0 auto", display: "table", zoom: "1" }}
    >
      <Container>
        <div>
          <Button title="FILTER" icon="fa-search" large onClick={handleSearch} />
        </div>
        <div style={{ minWidth: 240 }}>
          <TestingCategoriesSelect
            testing_category_ids={testingCategoryIds}
            handleSelectChange={(options) => {
              setTestingCategoryIds(options.map((o) => o.value));
            }}
          />
        </div>
        <div style={{ minWidth: 280 }}>
          <TechniquesSelect
            technique_ids={techniqueIds}
            handleSelectChange={(options) => {
              setTechniqueIds(options.map((o) => o.value));
            }}
          />
        </div>
        <div style={{ minWidth: 200 }}>
          <MatricesSelect
            handleSelectChange={(options) => {
              setMatrixIds(options.map((o) => o.value));
            }}
            matrix_ids={matrixIds}
          />
        </div>
        <div style={{ minWidth: 230 }}>
          <CompanyDropDown onChange={(id) => setCompanyId(id)} />
        </div>
      </Container>
      <div style={{ fontSize: "12pt" }}>
        <Link onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}>
          <i className={showAdvancedOptions ? "fa fa-caret-up" : "fa fa-caret-down"} />
          &nbsp;&nbsp; Show Advanced Options
        </Link>
        {showAdvancedOptions && <br />}
        {showAdvancedOptions && (
          <div>
            <label style={{ marginRight: 40 }}>
              <input
                type="checkbox"
                checked={exceedAnalysisTime}
                onClick={() => setExceedAnalysisTime(!exceedAnalysisTime)}
              />
              &nbsp; Only show trays with samples exceeding test analysis time?
            </label>
            <label>
              <input
                type="checkbox"
                checked={includeTechniques}
                onClick={() => setIncludeTechniques(!includeTechniques)}
              />
              &nbsp; Show techniques?
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
